module.exports = __webpack_public_path__ + "static/media/gy.13687832.svg";